import React from "react";
import PropTypes from "prop-types";
import { Icon } from "rhombus-react";
import { useTooltipRebuild } from "hooks/useTooltipRebuild";

import "./ContentFeedItems.css";

function buildTooltipContent(eligibleItems, totalItems) {
	return `Eligible items: ${eligibleItems}<br/>Total items: ${totalItems}`;
}

export default function ContentFeedItems({ dependentValues }) {
	const { eligibleItems, totalItems } = dependentValues;

	useTooltipRebuild(eligibleItems, totalItems);

	const showDiscrepancyWarning = eligibleItems !== totalItems;
	const tooltipContent = showDiscrepancyWarning ? buildTooltipContent(eligibleItems, totalItems) : null;

	return (
		<div className="content-feed-items-cell">
			<span className="content-feed-items-count">
				{eligibleItems}
			</span>
			{showDiscrepancyWarning && (
				<Icon
					name="fas fa-info-circle"
					className="content-feed-items-warning-icon"
					data-tip={tooltipContent}
					data-html={true}
				/>
			)}
		</div>
	);
}

ContentFeedItems.displayName = "ContentFeedItems";

ContentFeedItems.propTypes = {
	dependentValues: PropTypes.shape({
		eligibleItems: PropTypes.number.isRequired,
		totalItems: PropTypes.number.isRequired,
	}),
};
